import * as events from '@/events'

export default {
  mounted () {
    if (this.preload) this.preloadByType(this.preload.type)
  },
  
  methods: {
    initMapServiceOnScroll () {
      document.addEventListener('scroll', this.onViewportReach)
    },

    removeMapServiceInitializer () {
      document.removeEventListener('scroll', this.onViewportReach)
    },

    initMapServiceOnMount () {
      events.hotelNavigationUpdated.subscribe(this.mountHotelMap)
    },

    mountHotelMap () {
      if (this.$el.clientHeight && !this.dataReady) {
        this.$emit('reachViewport')
        this.markDataAsReady()
      }
    },

    preloadByType (type) {
      if (type === 'scroll') this.initMapServiceOnScroll()
      if (type === 'mount') this.initMapServiceOnMount()
    },

    onViewportReach () {
      if (this.isInViewport(this.$el) && !this.dataReady) {
        this.$emit('reachViewport')
        this.markDataAsReady()
        this.removeMapServiceInitializer()
      }
    },

    isInViewport (el) {
      const elBottom = el.offsetTop + el.offsetHeight
      const vTop = window.pageYOffset + window.innerHeight - (el.offsetHeight / 2)
      return elBottom > window.pageYOffset && el.offsetTop < vTop
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/googleMap/PreloaderMixin.js